import React, { ReactNode } from 'react'
import { RowWrapper } from './style'

const Row = ({
  children,
  styleRow,
}: {
  children: ReactNode
  styleRow?: string
}) => {
  return <RowWrapper styleRow={styleRow}>{children}</RowWrapper>
}

export default Row
